(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rbc-event-checkout"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const boot=()=>{
    const box=document.querySelector('[data-rbc-event-checkout]');
    const root=document.querySelector('[data-rbc-e][data-rbc-event="1"]');
    if(!box||!root||box.dataset.initialized)return;
    box.dataset.initialized='1';
    const review=root.querySelector('[data-step="3"]');
    if(!review)return;
    review.append(box);box.hidden=false;
    const config=JSON.parse(box.querySelector('[data-event-config]').textContent);
    const copy=JSON.parse(box.querySelector('[data-event-text]').textContent);
    const q=selector=>box.querySelector(selector);
    const qty=q('[data-event-quantity]'),add=q('[data-event-add]'),pay=q('[data-event-pay]'),status=q('[data-event-status]');
    const dock=q('[data-event-dock]'),dq=selector=>dock.querySelector(selector);
    const dockQty=dq('[data-event-dock-quantity]'),dockAdd=dq('[data-event-dock-add]'),dockPay=dq('[data-event-dock-pay]'),dockStatus=dq('[data-event-dock-status]'),dockToggle=dq('[data-event-dock-toggle]'),dockControls=dq('.rbc-event-dock__controls');
    const dockSpace=document.createElement('div');dockSpace.setAttribute('aria-hidden','true');dockSpace.setAttribute('data-html2canvas-ignore','true');
    document.body.append(dock,dockSpace);document.body.dataset.rbcEventDock='1';dock.hidden=false;
    const processing=document.createElement('div');processing.className='rbc-event-processing';processing.hidden=true;processing.setAttribute('role','status');processing.setAttribute('aria-live','assertive');processing.setAttribute('aria-busy','true');processing.setAttribute('data-html2canvas-ignore','true');
    processing.innerHTML='<div class="rbc-event-processing__card"><span class="rbc-event-processing__spinner" aria-hidden="true"></span><strong data-event-processing-title></strong><p data-event-processing-copy></p><div class="rbc-event-processing__bar" aria-hidden="true"><i data-event-processing-bar></i></div></div>';
    document.body.append(processing);
    const processingTitle=processing.querySelector('[data-event-processing-title]'),processingCopy=processing.querySelector('[data-event-processing-copy]'),processingBar=processing.querySelector('[data-event-processing-bar]');
    let processingTimer=0,processingProgress=0;
    const showProcessing=(message,progress)=>{
      processingProgress=Math.max(processingProgress,Math.min(100,Number(progress)||0));
      processingTitle.textContent=message||copy.uploading;processingCopy.textContent=message===copy.ready?copy.ready:message===copy.verifying?copy.verifying:copy.uploading;
      processingBar.style.width=processingProgress+'%';processing.hidden=false;document.body.classList.add('rbc-event-processing-open');
    };
    const beginProcessing=(message=copy.uploading,progress=8)=>{
      showProcessing(message,progress);
      if(processingTimer)return;
      processingTimer=setInterval(()=>{if(processing.hidden)return;processingProgress=Math.min(88,processingProgress+.7);processingBar.style.width=processingProgress+'%'},1000);
    };
    const advanceProcessing=(message,progress)=>showProcessing(message,progress);
    const endProcessing=()=>{clearInterval(processingTimer);processingTimer=0;processingProgress=0;processing.hidden=true;processingBar.style.width='8%';document.body.classList.remove('rbc-event-processing-open')};
    const models=['112','112camo','168','168p','355','6511','6606','ponytail','6606camo','beanie'];
    const basket=[];
    let inventory=JSON.parse(document.querySelector('[data-event-inventory]').textContent);
    const inventoryMode=inventory.enabled===true;
    const stockKey=details=>details.hatStyleKey+'|'+details.hatColor;
    const stockVariant=details=>inventory.variants?.[inventory.keys?.[stockKey(details)]];
    const stockValid=v=>v?.tracked===true&&v?.deny===true&&v?.available===true&&Number.isSafeInteger(v.id)&&Number.isInteger(v.quantity)&&v.quantity>0;
    const selectedDetails=()=>({hatStyleKey:root.dataset.hatStyleKey,hatColor:root.dataset.hatColor});
    const remaining=()=>{
      if(!inventoryMode)return 999;
      const details=selectedDetails(),v=stockVariant(details);
      return stockValid(v)?Math.max(0,v.quantity-basket.filter(item=>stockKey(item.details)===stockKey(details)).reduce((n,item)=>n+item.quantity,0)):0;
    };
    let stockVerified=true;
    let unavailableStock=new Set(JSON.parse(document.querySelector('[data-event-stock]').textContent).filter(Boolean));
    let busy=false,committing=false,navigating=false;
    const translate=(key,values={})=>Object.entries(values).reduce((s,[k,v])=>s.replaceAll('['+k+']',String(v)),copy[key]||key);
    const money=cents=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(cents/100);
    const rate=(model,totalCount,performanceCount)=>{
      const base=model==='355'?(performanceCount>=6?3000:totalCount>=6?3500:4000):model==='beanie'?(totalCount>=6?2300:2500):(totalCount>=12?2300:totalCount>=6?2500:3000);
      return base+(['112camo','168p','6606camo'].includes(model)?200:0);
    };
    const modelKey=()=>{const key=root.dataset.hatStyleKey;if(key==='6606'&&/multicam/i.test(root.dataset.hatColor||''))return '6606camo';if(['112','112p','112pfp'].includes(key))return /camo|realtree|mossy oak|kryptek/i.test(root.dataset.hatColor||'')?'112camo':'112';return key};
    const label=model=>({'168p':'168P','112camo':'112 Camo','6511':'Flexfit 6511','6606':'Yupoong 6606','6606camo':'Yupoong 6606 Camo','beanie':'Yupoong 1501KC Beanie','ponytail':'Infinity Her Ponytail'}[model]||'Richardson '+model);
    const basketCounts=(extraModel='',extraQuantity=0)=>({total:basket.reduce((sum,item)=>sum+item.quantity,0)+extraQuantity,performance:basket.filter(item=>item.model==='355').reduce((sum,item)=>sum+item.quantity,0)+(extraModel==='355'?extraQuantity:0)});
    const quantity=()=>{const value=Number(qty.value);if(!Number.isInteger(value)||value<1||value>999)throw new Error(copy.quantity_error);return value};
    const configured=()=>config.enabled&&config.orderingOpen===true&&config.currency==='USD'&&models.every(model=>{const p=config.products[model];return Number.isSafeInteger(p.id)&&p.id>0&&p.available===true&&p.price===rate(model,1,model==='355'?1:0)})&&new Set(models.map(model=>config.products[model].id)).size===models.length;
    const tell=(message,error=false)=>{status.textContent=message;status.dataset.error=String(error);dockStatus.textContent=message===copy.added?copy.sticky_added:message;dockStatus.dataset.error=String(error);dockStatus.hidden=!message};
    const nameAt=selector=>root.querySelector(selector)?.textContent.trim()||'';
    const metadata=()=>{
      const state=root.rbcLegacyBuilder?.state||{},d=root.dataset;
      const selected=[...root.querySelectorAll('input:checked')].map(input=>({name:input.name,value:input.value}));
      return {hatStyle:d.hatStyle||'',hatColor:d.hatColor||'',hatStyleKey:d.hatStyleKey||'',patchFinish:nameAt('[data-r-finish]'),patchFinishKey:state.finish||'',patchShape:nameAt('[data-r-shape]'),patchShapeKey:state.shape||'',patchBorder:nameAt('[data-r-border]'),patchSize:nameAt('[data-r-size]'),patchPosition:nameAt('[data-r-place]'),artworkName:nameAt('[data-r-logo]'),patchType:d.rbcPatchType||'engraved',selected,geometry:Object.fromEntries(Object.entries(d).filter(([key])=>/^rbc(Patch|Logo|Reverse|Engrav|CutAround)/.test(key))),patchStyle:root.querySelector('[data-patch]')?.style.cssText||'',engravingStyle:root.querySelector('[data-engraving]')?.style.cssText.replace(/url\([^)]*\)/g,'url(artwork)')||''};
    };
    const validFile=file=>file instanceof Blob&&file.size>0&&file.size<=10485760&&typeof file.name==='string';
    const draw=()=>{
      const model=modelKey(),left=remaining(),stockLabel=q('[data-event-stock-count]');
      qty.max=String(Math.max(1,Math.min(999,left)));dockQty.max=qty.max;
      stockLabel.hidden=!inventoryMode;
      stockLabel.textContent=left<=0?copy.stock_sold:translate(left<=inventory.threshold?'stock_low':'stock_available',{count:left});
      try{const count=quantity(),counts=basketCounts(model,count),unit=rate(model,counts.total,counts.performance);q('[data-event-current]').textContent=models.includes(model)?translate('current',{model:label(model),quantity:count,price:money(unit),amount:money(count*unit)}):copy.model_error}catch(_){q('[data-event-current]').textContent=copy.quantity_error}
      const list=q('[data-event-items]');list.replaceChildren();
      basket.forEach(item=>{
        const row=document.createElement('div');row.className='rbc-event-line';
        const image=document.createElement('img');image.src=item.preview;image.alt=item.details.hatStyle+' · '+item.details.hatColor;image.width=72;image.height=72;
        const body=document.createElement('div'),title=document.createElement('strong'),detail=document.createElement('small'),cost=document.createElement('small'),remove=document.createElement('button');
        title.textContent=item.quantity+' × '+item.details.hatStyle+' · '+item.details.hatColor;
        detail.textContent=[item.details.patchFinish,item.details.patchShape,item.details.patchSize,item.details.patchPosition].join(' · ');
        const counts=basketCounts(),unit=rate(item.model,counts.total,counts.performance);cost.textContent=money(unit)+' × '+item.quantity+' = '+money(unit*item.quantity);
        remove.type='button';remove.textContent=copy.remove;remove.disabled=busy||committing;remove.setAttribute('aria-label',copy.remove+' '+title.textContent);
        remove.addEventListener('click',()=>{if(busy||committing)return;URL.revokeObjectURL(item.preview);basket.splice(basket.indexOf(item),1);draw()});
        body.append(title,detail,cost,remove);row.append(image,body);list.append(row);
      });
      const counts=basketCounts(),count=counts.total,amount=basket.reduce((sum,item)=>sum+item.quantity*rate(item.model,counts.total,counts.performance),0);
      q('[data-event-subtotal]').textContent=count?translate('subtotal',{count,amount:money(amount)}):copy.empty;
      add.disabled=busy||committing||root.dataset.rbcEventNoStock==='1'||!stockVerified||left<Number(qty.value)||left<1||unavailableStock.has(stockKey(selectedDetails()))||!Number.isInteger(Number(qty.value))||Number(qty.value)<1;
      qty.disabled=busy||committing||left<1;
      let basketAvailable=true;try{assertStock(basket,inventory,unavailableStock)}catch(_){basketAvailable=false}
      pay.disabled=busy||!basket.length||!configured()||!stockVerified||!basketAvailable;
      q('[data-event-open-status]').textContent=config.orderingOpen===true?copy.event_open:copy.event_closed;
      q('[data-event-pending]').hidden=!config.orderingOpen||configured();
      if(document.activeElement!==dockQty)dockQty.value=qty.value;
      dockQty.disabled=qty.disabled;dockAdd.disabled=add.disabled;dockPay.disabled=pay.disabled;
      dock.setAttribute('aria-busy',String(busy));
      try{const selected=quantity(),counts=basketCounts(model,selected),unit=rate(model,counts.total,counts.performance);dq('[data-event-dock-price]').textContent=models.includes(model)?money(unit*selected):'—';dq('[data-event-dock-each]').textContent=models.includes(model)?translate('sticky_each',{price:money(unit)}):''}catch(_){dq('[data-event-dock-price]').textContent='—';dq('[data-event-dock-each]').textContent=copy.sticky_quantity_error}
      const orderLabel=translate('sticky_order',{count,amount:money(amount)});
      dq('[data-event-dock-review]').textContent=orderLabel;
      dq('[data-event-dock-review]').setAttribute('aria-label',copy.sticky_review+' · '+orderLabel);
      dq('[data-event-dock-hint]').textContent=!config.orderingOpen?copy.sticky_closed:!configured()?copy.sticky_pending:copy.sticky_before_tax;
      if(dockControls.hidden)dockToggle.textContent=orderLabel+' ▴';
    };
    add.addEventListener('click',async()=>{
      if(busy||committing)return;
      try{
        const count=quantity(),model=modelKey();
        if(!models.includes(model))throw new Error(copy.model_error);
        if(basket.length>=20)throw new Error(copy.memory_limit);
        const art=root.rbcArtworkFiles,original=art?.original(),prepared=art?.prepared(),revision=art?.revision();
        if(!validFile(original))throw new Error(copy.upload_first);
        if(root.dataset.rbcArtworkState!=='ready'||!validFile(prepared))throw new Error(copy.wait_artwork);
        const capture=root.rbcMockupCapture;
        if(typeof capture?.captureFile!=='function'||!(capture.version===2||capture.nativeVersion===2&&capture.rbcFastCompatible===true))throw new Error(copy.capture_missing);
        const details=metadata(),fingerprint=JSON.stringify(details);
        const v=stockVariant(details),variantId=inventoryMode?v?.id:config.products[model]?.id;
        const candidate={model,quantity:count,details,variantId,inventoryMode};
        busy=true;draw();tell(copy.saving);
        await checkEventStatus([candidate]);
        const mockup=await capture.captureFile();
        if(typeof root.rbcProductionCapture?.captureFiles!=='function')throw new Error(copy.capture_missing);
        const production=await root.rbcProductionCapture.captureFiles();
        if(!validFile(production.trace)||!validFile(production.svg))throw new Error(copy.file_error);
        if(!validFile(mockup))throw new Error(copy.file_error);
        if(art!==root.rbcArtworkFiles||revision!==art.revision()||original!==art.original()||prepared!==art.prepared()||fingerprint!==JSON.stringify(metadata()))throw new Error(copy.changed);
        const bytes=basket.reduce((sum,item)=>sum+item.original.size+item.prepared.size+item.mockup.size+item.production.trace.size+item.production.svg.size,0)+original.size+prepared.size+mockup.size+production.trace.size+production.svg.size;
        if(bytes>83886080)throw new Error(copy.memory_limit);
        assertStock([...basket,candidate],inventory,unavailableStock);
        basket.push({id:crypto.randomUUID(),model,variantId,inventoryMode,quantity:count,details,original,prepared,mockup,production,preview:URL.createObjectURL(mockup)});
        tell(copy.added);
      }catch(error){tell(error.message||copy.capture_missing,true)}finally{busy=false;draw()}
    });
    const route=path=>(window.Shopify?.routes?.root||'/')+path;
    const failure=(message,code,response)=>Object.assign(new Error(message),{code,httpStatus:response?.status,responseType:response?.headers?.get('content-type')||''});
    const request=async(path,options={})=>{
      const response=await fetch(route(path),{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(90000),...options,headers:{Accept:'application/json',...options.headers}});
      let result;try{result=await response.json()}catch(_){throw failure(copy.network_error,'cart_response_format',response)}
      if(!response.ok){const error=new Error(typeof result.description==='string'?result.description:copy.network_error);error.rejected=response.status>=400&&response.status<500;throw error}
      return result;
    };
    const stockError=message=>Object.assign(new Error(message),{stockChanged:true});
    const assertStock=(items,current,unavailable,cart=null)=>{
      if((current.enabled===true)!==inventoryMode)throw stockError(copy.stock_mode_changed);
      const totals=new Map();
      for(const item of items){
        const key=stockKey(item.details);
        if(unavailable.has(key))throw stockError(copy.stock_changed.replace('[hat]',item.details.hatStyle+' · '+item.details.hatColor));
        if(!inventoryMode)continue;
        const v=current.variants?.[current.keys?.[key]];
        if(!stockValid(v)||v.id!==item.variantId||v.price!==rate(item.model,1,item.model==='355'?1:0)||v.model!==item.model)throw stockError(copy.stock_changed.replace('[hat]',item.details.hatStyle+' · '+item.details.hatColor));
        totals.set(v.id,(totals.get(v.id)||0)+item.quantity);
        if(totals.get(v.id)>v.quantity)throw stockError(translate('stock_limit',{hat:item.details.hatColor,count:v.quantity}));
      }
      if(inventoryMode&&cart){
        for(const [id,count] of totals){
          const other=cart.items.filter(line=>line.variant_id===id&&!items.some(item=>item.id&&line.properties?._rbc_event_design===item.id)).reduce((n,line)=>n+line.quantity,0);
          const v=Object.values(current.variants).find(v=>v?.id===id);
          if(count+other>v.quantity)throw stockError(translate('stock_limit',{hat:items.find(item=>item.variantId===id).details.hatColor,count:Math.max(0,v.quantity-other)}));
        }
      }
    };
    const checkEventStatus=async(extra=[],cart=null)=>{
      const url=new URL(location.href);
      const previewTheme=window.Shopify?.theme;
      if(previewTheme?.role==='unpublished'&&Number.isSafeInteger(previewTheme.id))url.searchParams.set('preview_theme_id',String(previewTheme.id));
      const stockSection=window.document.querySelector('[data-event-stock]')?.dataset.sectionId;
      url.searchParams.set('sections',[box.dataset.eventSection,stockSection].filter(Boolean).join(','));
      url.searchParams.set('_rbc_event_check',String(Date.now()));
      const response=await fetch(url,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(15000),headers:{Accept:'application/json'}});
      if(!response.ok)throw failure(copy.network_error,'event_status_http',response);
      let sections;try{sections=await response.json()}catch(_){throw failure(copy.network_error,'event_status_format',response)}
      let html=sections[box.dataset.eventSection];
      if(typeof html==='string'&&typeof sections[stockSection]==='string')html+=sections[stockSection];
      if(typeof html!=='string'||(!html.includes('data-event-stock')||!html.includes('data-event-inventory'))){
        url.searchParams.delete('sections');
        const page=await fetch(url,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(15000),headers:{Accept:'text/html'}});
        if(!page.ok)throw failure(copy.network_error,'event_page_http',page);
        html=await page.text();
      }
      const document=new DOMParser().parseFromString(html,'text/html');
      const node=document.querySelector('[data-event-config]');
      if(!node)throw failure(copy.network_error,'event_config_missing',response);
      const stockNode=document.querySelector('[data-event-stock]');
      if(!stockNode)throw new Error(copy.stock_unverified);
      const inventoryNode=document.querySelector('[data-event-inventory]');
      if(!inventoryNode)throw new Error(copy.stock_unverified);
      const unavailable=new Set(JSON.parse(stockNode.textContent).filter(Boolean));
      const nextInventory=JSON.parse(inventoryNode.textContent);
      if((nextInventory.enabled===true)!==inventoryMode){stockVerified=false;draw();throw new Error(copy.stock_mode_changed)}
      inventory=nextInventory;unavailableStock=unavailable;root.rbcEventInventory=inventory;stockVerified=true;
      root.dispatchEvent(new CustomEvent('rbc:event-inventory-change',{detail:{inventory,unavailable:[...unavailable]}}));
      draw();
      assertStock([...basket,...extra],inventory,unavailable,cart);
      const current=JSON.parse(node.textContent);
      if(current.orderingOpen!==true||current.enabled!==true){config.orderingOpen=false;draw();throw new Error(copy.event_closed)}
      if(['eventName','eventDates','pickupAddress','combinedPricing'].some(key=>current[key]!==config[key])||models.some(model=>current.products?.[model]?.id!==config.products[model].id))throw new Error(copy.event_changed);
    };
    const attachmentNames=['Original artwork','Converted logo','Finished mock-up','Patch trace PNG','Patch layout SVG'];
    const hosted=value=>{if(typeof value!=='string')return false;try{const url=new URL(value,location.origin);return url.protocol==='https:'&&(url.hostname===location.hostname||url.hostname==='cdn.shopify.com'||url.hostname.endsWith('.shopify.com')||url.hostname.endsWith('.shopifycdn.net'))&&/\/uploads\//.test(url.pathname)}catch(_){return false}};
    const inches=value=>(Number(value||0)/25.4).toFixed(2);
    const properties=item=>{
      const d=item.details,g=d.geometry;
      return {'Order source':'Event / Mobile Trailer','Event':config.eventName||'Mobile Trailer','Event dates':config.eventDates||'','Pickup':'Rust Belt Customz trailer','Pickup address':config.pickupAddress||'','Design reference':item.id,'Hat model':d.hatStyle,'Hat color':d.hatColor,'Camo surcharge per hat':['112camo','168p','6606camo'].includes(item.model)?'$2.00':'$0.00','Patch finish':d.patchFinish,'Patch shape':d.patchShape,'Patch border':d.patchBorder,'Patch size':d.patchSize,'Patch placement':d.patchPosition,'Patch offset X (in)':inches(g.rbcPatchXMm),'Patch offset Y (in)':inches(g.rbcPatchYMm),'Patch rotation (degrees)':g.rbcPatchRotationDeg||'0','Engraving style':d.selected.find(input=>/reverse|engraving/i.test(input.name))?.value||g.rbcEngravingMode||'standard','Artwork filename':item.original.name,'_rbc_event_design':item.id,'_rbc_event_model':item.model,'Production size (mm)':Number(item.production.widthMm.toFixed(6))+' × '+Number(item.production.heightMm.toFixed(6)),'Production size (in)':inches(item.production.widthMm)+' × '+inches(item.production.heightMm),'Production SVG contents':'Vector cut outline + 600 DPI engraving bitmap','_rbc_event_version':'3','_rbc_event_geometry':JSON.stringify(g),'_rbc_event_controls':JSON.stringify(d.selected),'_rbc_event_patch_style':d.patchStyle,'_rbc_event_engraving_style':d.engravingStyle};
    };
    const match=(cart,item)=>cart.items.filter(line=>line.properties?._rbc_event_design===item.id);
    const verifyLine=(cart,item)=>{
      const lines=match(cart,item);
      if(lines.length!==1)throw new Error(copy.cart_error);
      const line=lines[0];
      if(line.variant_id!==item.variantId||line.quantity!==item.quantity)throw new Error(copy.cart_error);
      if(!attachmentNames.every(name=>hosted(line.properties?.[name])))throw new Error(copy.attachment_error);
      const expected=properties(item);
      if(!Object.entries(expected).every(([key,value])=>String(line.properties?.[key]??'')===String(value)))throw new Error(copy.cart_error);
      return line;
    };
    const verifyPrices=cart=>{
      if(cart.currency!=='USD')throw new Error(copy.price_error);
      const variantModels=Object.fromEntries(models.map(model=>[config.products[model].id,model]));
      Object.values(inventory.variants).filter(Boolean).forEach(v=>variantModels[v.id]=v.model);
      const eventLines=cart.items.filter(line=>variantModels[line.variant_id]);
      const totalCount=eventLines.reduce((sum,line)=>sum+line.quantity,0);
      const performanceCount=eventLines.filter(line=>variantModels[line.variant_id]==='355').reduce((sum,line)=>sum+line.quantity,0);
      models.forEach(model=>{
        const lines=cart.items.filter(line=>variantModels[line.variant_id]===model);
        if(lines.some(line=>line.final_line_price!==line.quantity*rate(model,totalCount,performanceCount)))throw new Error(copy.price_error);
      });
    };
    pay.addEventListener('click',async()=>{
      if(busy||!basket.length||!configured())return;
      busy=true;draw();tell(copy.uploading);beginProcessing(copy.uploading,10);
      let stage='event_status';
      try{
        await checkEventStatus();advanceProcessing(copy.verifying,24);
        stage='cart_read';
        let cart=await request('cart.js');advanceProcessing(copy.uploading,34);
        for(const item of basket){
          stage='event_status';
          await checkEventStatus([],cart);
          if(!match(cart,item).length){
            if(item.uncertain)throw new Error(copy.network_error);
            const body=new FormData();body.append('id',String(item.variantId));body.append('quantity',String(item.quantity));
            Object.entries(properties(item)).forEach(([key,value])=>body.append('properties['+key+']',String(value)));
            [item.original,item.prepared,item.mockup,item.production.trace,item.production.svg].forEach((file,index)=>body.append('properties['+attachmentNames[index]+']',file,file.name));
            stage='artwork_upload';committing=true;advanceProcessing(copy.uploading,Math.min(82,46+Math.round((basket.indexOf(item)+1)/Math.max(1,basket.length)*30)));
            try{await request('cart/add.js',{method:'POST',body})}catch(error){
              if(!error.rejected)item.uncertain=true;
              cart=await request('cart.js');
              if(!match(cart,item).length)throw error;
            }
            cart=await request('cart.js');
          }
          verifyLine(cart,item);advanceProcessing(copy.verifying,88);
        }
        stage='cart_verification';
        tell(copy.verifying);
        cart=await request('cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'RBC event source':'Event / Mobile Trailer','RBC event name':config.eventName||'Mobile Trailer','RBC event dates':config.eventDates||'','RBC pickup address':config.pickupAddress||'','RBC event builder':'/pages/event-hat-builder'}})});
        basket.forEach(item=>verifyLine(cart,item));verifyPrices(cart);
        if(cart.attributes?.['RBC event source']!=='Event / Mobile Trailer')throw new Error(copy.cart_error);
        await checkEventStatus([],cart);
        navigating=true;tell(copy.ready);advanceProcessing(copy.ready,100);location.assign(route('cart'));
      }catch(error){endProcessing();console.error('[RBC event checkout]',JSON.stringify({stage,code:error.code||error.name,httpStatus:error.httpStatus,responseType:error.responseType}));tell((error.message||copy.network_error)+(committing?' '+copy.locked:''),true);q('[data-event-cart]').hidden=!committing;busy=false;draw()}
    });
    const openEventCart=event=>{
      if(!root.isConnected||(!basket.length&&!busy))return;
      const target=event.target instanceof Element?event.target.closest('#cart-icon-bubble,a[href]'):null;
      if(!target)return;
      const isHeader=target.id==='cart-icon-bubble';
      let isCart=false;
      if(target instanceof HTMLAnchorElement){const url=new URL(target.href,location.href);isCart=url.origin===location.origin&&url.pathname.replace(/\/$/,'')===route('cart').replace(/\/$/,'')}
      if(!isHeader&&!isCart)return;
      if(target.closest('[data-rbc-event-checkout]'))return;
      event.preventDefault();event.stopImmediatePropagation();
      if(busy){beginProcessing(committing?copy.uploading:copy.saving,committing?55:18);return;}
      if(pay.disabled){tell(!config.orderingOpen?copy.event_closed:copy.pending,true);return}
      pay.click();
    };
    document.addEventListener('click',openEventCart,true);
    dockQty.addEventListener('input',()=>{qty.value=dockQty.value;draw()});
    dockAdd.addEventListener('click',()=>add.click());
    dockPay.addEventListener('click',()=>pay.click());
    dq('[data-event-dock-review]').addEventListener('click',()=>{const heading=box.querySelector('h2');heading.tabIndex=-1;heading.focus({preventScroll:true});box.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'center'})});
    dockToggle.addEventListener('click',()=>{const minimized=!dockControls.hidden;dockControls.hidden=minimized;dock.classList.toggle('is-minimized',minimized);dockToggle.setAttribute('aria-expanded',String(!minimized));dockToggle.setAttribute('aria-label',minimized?copy.sticky_expand:copy.sticky_minimize);dockToggle.textContent=minimized?dq('[data-event-dock-review]').textContent+' ▴':'−';positionDock()});
    let dockFrame=0,observedToolbar=null,disposed=false;
    const disposeDock=()=>{if(disposed)return;disposed=true;cancelAnimationFrame(dockFrame);dockResize.disconnect();toolbarObserver.disconnect();window.removeEventListener('scroll',queueDock);window.removeEventListener('resize',queueDock);window.visualViewport?.removeEventListener('resize',queueDock);window.visualViewport?.removeEventListener('scroll',queueDock);document.removeEventListener('shopify:section:unload',unloadDock);document.removeEventListener('click',openEventCart,true);dock.remove();dockSpace.remove();delete document.body.dataset.rbcEventDock;document.body.style.removeProperty('--rbc-event-verification-bottom')};
    const positionDock=()=>{
      if(!root.isConnected||!box.isConnected){disposeDock();return}
      const frame=document.getElementById('PBarNextFrameWrapper')||document.getElementById('PBarNextFrame');
      if(frame!==observedToolbar){if(observedToolbar)dockResize.unobserve(observedToolbar);observedToolbar=frame;if(frame)dockResize.observe(frame)}
      const rect=frame?.getBoundingClientRect(),viewport=window.visualViewport,visibleTop=viewport?.offsetTop||0,visibleBottom=visibleTop+(viewport?.height||innerHeight);
      const bottom=rect&&rect.height>0&&rect.top>visibleTop+(visibleBottom-visibleTop)/2&&rect.top<visibleBottom?Math.min(rect.height,Math.max(0,visibleBottom-rect.top)):0;
      dock.style.setProperty('--rbc-event-dock-bottom',bottom+'px');
      const clearance=dock.getBoundingClientRect().height+bottom+20;
      dockSpace.style.height=clearance+'px';document.body.style.setProperty('--rbc-event-verification-bottom',clearance+'px');
    };
    const queueDock=()=>{if(!dockFrame&&!disposed)dockFrame=requestAnimationFrame(()=>{dockFrame=0;positionDock()})};
    const dockResize=new ResizeObserver(queueDock),toolbarObserver=new MutationObserver(queueDock);
    const unloadDock=event=>{if(event.detail?.sectionId===box.dataset.eventSection)disposeDock()};
    dockResize.observe(dock);toolbarObserver.observe(document.body,{childList:true});
    window.addEventListener('scroll',queueDock,{passive:true});window.addEventListener('resize',queueDock,{passive:true});window.visualViewport?.addEventListener('resize',queueDock,{passive:true});window.visualViewport?.addEventListener('scroll',queueDock,{passive:true});document.addEventListener('shopify:section:unload',unloadDock);
    positionDock();
    let refreshing=false;
    const refreshInventory=async()=>{
      if(!inventoryMode||refreshing||busy||committing||document.hidden||!root.isConnected)return;
      refreshing=true;
      try{await checkEventStatus()}catch(error){if(!error.stockChanged)stockVerified=false;draw();tell(error.message||copy.stock_unverified,true)}finally{refreshing=false}
    };
    const inventoryTimer=setInterval(()=>{if(!root.isConnected)clearInterval(inventoryTimer);else refreshInventory()},30000);
    document.addEventListener('visibilitychange',refreshInventory);
    window.addEventListener('focus',refreshInventory);
    qty.addEventListener('input',draw);
    root.addEventListener('rbc:hat-style-change',draw);
    window.addEventListener('beforeunload',event=>{if(basket.length&&!navigating&&!committing){event.preventDefault();event.returnValue=''}});
    draw();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rbc-onsite-events"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    root.querySelectorAll('[data-rbc-onsite]').forEach((el) => {
      if (el.dataset.rbcReady) return;
      el.dataset.rbcReady = 'true';
      const sticky = el.querySelector('[data-rbc-sticky]');
      const quote = el.querySelector('[data-rbc-quote]');
      const hero = el.querySelector('.rbc-onsite__hero');
      let heroVisible = true;
      let quoteVisible = false;
      if (sticky && quote && hero && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === hero) heroVisible = entry.isIntersecting;
            if (entry.target === quote) quoteVisible = entry.isIntersecting;
          });
          sticky.hidden = heroVisible || quoteVisible;
        });
        observer.observe(hero);
        observer.observe(quote);
        el.addEventListener('rbc:cleanup', () => observer.disconnect(), {once: true});
      }
      const result = el.querySelector('[data-rbc-result]');
      if (result) { result.scrollIntoView({block: 'center'}); result.focus({preventScroll: true}); }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-rbc-onsite]').forEach((el) => el.dispatchEvent(new Event('rbc:cleanup'))));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rbc-personalized-boards"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-boards]').forEach(root=>{
 if(root.dataset.initialized)return;root.dataset.initialized='true';
 const form=root.querySelector('form'),select=root.querySelector('[data-colors]'),inputs=[...root.querySelectorAll('[data-qty]')],status=root.querySelector('[data-status]'),messages=JSON.parse(root.querySelector('[data-messages]').textContent);
 const chosen=()=>inputs.filter(x=>!x.disabled&&(select.value==='both'||select.value===x.dataset.qty));
 const refresh=()=>{root.querySelectorAll('[data-row]').forEach(x=>x.hidden=select.value!=='both'&&select.value!==x.dataset.row);let n=chosen().reduce((s,x)=>s+(Number(x.value)||0),0);let p=n>=80?65:n>=40?68:n>=24?70:n>=8?73:n>=4?77:80;root.querySelector('[data-total]').textContent=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(n*p);};
 select.addEventListener('change',refresh);inputs.forEach(x=>x.addEventListener('input',refresh));refresh();
 form.addEventListener('submit',async e=>{
 e.preventDefault();if(root.dataset.ready!=='true')return;
 const rows=chosen(),file=root.querySelector('[data-art]').files[0],notes=root.querySelector('[data-text]').value.trim();
 if(!rows.length||rows.some(x=>!Number.isInteger(Number(x.value))||Number(x.value)<1)||(!file&&!notes)){status.textContent=messages.invalid;return;}
 if(file&&file.size>20*1024*1024){status.textContent=messages.large;return;}
 const button=form.querySelector('button');button.disabled=true;status.textContent=messages.working;let completed=0;
 try{
 let properties={'Engraving instructions':notes};
 for(const row of rows){
 const data=new FormData();data.append('id',row.dataset.variant);data.append('quantity',row.value);
 Object.entries(properties).forEach(([k,v])=>{if(v)data.append('properties['+k+']',v);});
 if(file&&completed===0)data.append('properties[Artwork]',file,file.name);
 const response=await fetch(root.dataset.root+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
 const result=await response.json();if(!response.ok)throw new Error(result.description||messages.error);
 completed++;if(result.properties&&result.properties.Artwork)properties.Artwork=result.properties.Artwork;
 if(file&&!properties.Artwork)throw new Error(messages.error);
 }
 location.assign(root.dataset.root+'cart');
 }catch(error){status.textContent=messages.error+' '+error.message;if(completed===0)button.disabled=false;}
 });
});

  } catch(e) { console.error(e); }
})();
})();
